export default __webpack_public_path__ + "static/char-v-50-f34f8005b8db322f23bdf57145ee76fe.webp";